/* Sleepee 8.10: na karcie produktu (komputer, od 750 px) blok „Opis” (akordeon otwarty domyślnie) idzie pod galerię —
   pod galerią nie zostaje pusta lewa strona (uwaga Pawła). Materiały / Rozmiary / Wysyłka zostają w kolumnie zakupu pod ramkami.
   Poniżej 750 px Opis wraca na swoje miejsce. Style: assets/sleepee-propozycje.css (.sl-pdp-acc). */
(function () {
  var mq = window.matchMedia('(min-width: 750px)');
  function run() {
    var page = document.querySelector('.product__page');
    if (!page) return;
    var images = page.querySelector('.product__images');
    /* 13.10: lista ustalana raz (stan „open” przy pierwszym uruchomieniu) — zamknięcie/otwarcie akordeonu przez klienta nie przenosi bloków między kolumnami */
    if (!page.__slAcc) page.__slAcc = Array.prototype.filter.call(page.querySelectorAll('.product__block--accordion'), function (b) {
      var det = b.querySelector('details');
      return det && det.hasAttribute('open');
    });
    var blocks = page.__slAcc;
    if (!images || !blocks.length) return;
    var holder = page.querySelector('.sl-pdp-acc');
    if (mq.matches) {
      if (!holder) { holder = document.createElement('div'); holder.className = 'sl-pdp-acc'; images.appendChild(holder); }
      blocks.forEach(function (b) {
        if (!b.__slHome) { b.__slHome = { parent: b.parentNode, next: b.nextSibling }; }
        if (b.parentNode !== holder) holder.appendChild(b);
      });
    } else {
      blocks.forEach(function (b) {
        if (b.__slHome && b.parentNode !== b.__slHome.parent) {
          b.__slHome.parent.insertBefore(b, b.__slHome.next && b.__slHome.next.parentNode === b.__slHome.parent ? b.__slHome.next : null);
        }
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  mq.addEventListener ? mq.addEventListener('change', run) : mq.addListener(run);
  document.addEventListener('shopify:section:load', run);
})();

/* 2.11 (uwagi Łukasza PROD-003): po „Czytaj więcej” na dole opisu przycisk „Zwiń opis” — wraca do skróconej wersji
   i przewija do nagłówka opisu. Broadcast (toggle-ellipsis) sam nie umie zwinąć. Style: sleepee-mk.css (2.11). */
(function () {
  var L = { pl: 'Zwiń opis', en: 'Show less', de: 'Weniger anzeigen', fr: 'Réduire', nl: 'Minder tonen', uk: 'Згорнути опис' };
  function label() { var l = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase(); return L[l] || L.en; }
  function setup() {
    document.querySelectorAll('.product__block--accordion toggle-ellipsis').forEach(function (te) {
      if (te.__slLess) return;
      te.__slLess = true;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sl-ell-less';
      b.innerHTML = '<span>' + label() + '</span>';
      te.appendChild(b);
      b.addEventListener('click', function () {
        te.classList.remove('is-open');
        te.style.setProperty('--height', (te.getAttribute('data-height') || 175) + 'px');
        var top = te.closest('details') || te;
        var y = top.getBoundingClientRect().top + window.pageYOffset - 120;
        if (y < window.pageYOffset) window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();

/* 3.11 (audyt mobile): przyklejony pasek zakupu (cart-bar) chowa się, gdy na ekranie jest stopka —
   wcześniej zasłaniał dolne linki stopki. Styl: assets/sleepee-fix-product.css (.sl-cb-off). */
(function () {
  function setup() {
    var bar = document.querySelector('cart-bar');
    var foot = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
    if (!bar || !foot || !('IntersectionObserver' in window) || bar.__slFoot) return;
    bar.__slFoot = true;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { bar.classList.toggle('sl-cb-off', e.isIntersecting); });
    }).observe(foot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();

/* 3.11 (audyt mobile): pasek zakupu Broadcast przy produktach z wariantami zawsze pokazuje „Wybierz wariant” i tylko przewija
   do formularza — nawet gdy wariant (np. XS) jest już wybrany. Gdy główny przycisk „Dodaj do koszyka” jest aktywny, pasek
   przejmuje jego napis (z ceną) i klik w pasek klika główny przycisk (ten sam koszyk/szuflada co w formularzu).
   Gdy wariant niedostępny / przycisk wyłączony — zostaje oryginalne zachowanie Broadcast (przewinięcie).
   Broadcast przerysowuje wnętrze paska po zmianie wariantu, więc napis jest pilnowany obserwatorem. Styl: sleepee-fix-product.css §7. */
(function () {
  function setup() {
    var bar = document.querySelector('cart-bar');
    if (!bar || bar.__slAdd) return;
    var info = bar.closest('product-info') || document;
    var main = info.querySelector('[data-product-form] button[name="add"]');
    if (!main || !bar.querySelector('[data-cart-bar-scroll]')) return;
    bar.__slAdd = true;
    function ok() { return !main.disabled && main.getAttribute('aria-disabled') !== 'true' && !/sold|wyprzed|ausverk|épuis|epuis|uitverk/i.test(main.textContent); }
    function label() {
      var t = main.querySelector('.btn__text') || main;
      return (t.innerText || t.textContent).replace(/\s+/g, ' ').trim();
    }
    function sync() {
      var btn = bar.querySelector('[data-cart-bar-scroll]');
      var txt = btn && btn.querySelector('.btn__text');
      if (!txt) return;
      if (!txt.__slOrig) txt.__slOrig = txt.textContent;
      var on = ok();
      var want = on ? label() : txt.__slOrig;
      if (bar.classList.contains('sl-cb-add') !== on) bar.classList.toggle('sl-cb-add', on);
      if (want && txt.textContent !== want) txt.textContent = want;
    }
    bar.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cart-bar-scroll]') || !ok()) return;
      e.preventDefault(); e.stopPropagation();
      main.click();
    }, true);
    new MutationObserver(sync).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
    new MutationObserver(sync).observe(bar, { childList: true, subtree: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
